import { Tooltip } from '@mui/material';
import UntitledIcon, { TIconName } from '@payaca/untitled-icons';
import { FunctionComponent, type JSX } from 'react';
import './IconTooltip.sass';

type Props = {
  iconDefinition: TIconName;
  tooltipText: string;
  className?: string;
};

const IconTooltip: FunctionComponent<Props> = ({
  iconDefinition,
  tooltipText,
  className,
}: Props): JSX.Element | null => {
  return (
    <Tooltip title={tooltipText} arrow placement="top">
      <div className={`icon-tooltip ${className ? className : ''}`}>
        <UntitledIcon className="alert-icon" name={iconDefinition} />
      </div>
    </Tooltip>
  );
};

export default IconTooltip;

type AlertTooltipProps = Omit<Props, 'iconDefinition'>;

export const AlertTooltip: FunctionComponent<AlertTooltipProps> = ({
  tooltipText,
  className,
}: AlertTooltipProps): JSX.Element | null => {
  return (
    <IconTooltip
      tooltipText={tooltipText}
      iconDefinition="info-circle.3"
      className={`alert-tooltip ${className ? className : ''}`}
    />
  );
};
